function e(e){this.message=e;}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw "Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e;}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";

const getUsernameFromToken = (token) => {
  if (token) {
    const jwtTokenContent = o(token);
    return jwtTokenContent ? jwtTokenContent.user : undefined;
  }
};
const getTokenFromCurrentLocation = () => {
  const refreshToken = getParameterFromCurrentLocation('refreshToken');
  if (refreshToken) {
    return {
      refreshToken: refreshToken,
      accessToken: getParameterFromCurrentLocation('accessToken'),
    };
  }
  const compatibilityToken = getParameterFromCurrentLocation('token');
  if (compatibilityToken) {
    // eslint-disable-next-line no-console
    console.log('Compatibility token detected!', compatibilityToken);
    return {
      refreshToken: compatibilityToken,
      accessToken: compatibilityToken,
    };
  }
  return {};
};
function getParameterFromCurrentLocation(parameter) {
  var _a;
  const values = (_a = window.location.hash) === null || _a === void 0 ? void 0 : _a.slice(1).split('#').map(entry => {
    const splitEntry = entry.split('=');
    return { key: splitEntry[0], value: splitEntry[1] };
  }).filter(keyValuePair => keyValuePair.key === parameter).map(keyValuePair => keyValuePair.value);
  return values && values.length > 0 ? values[0] : undefined;
}
const getToken = () => {
  return window.accessToken;
};
const oneMinuteInSeconds = 60;
const defaultTokenRefreshRate = 5 * oneMinuteInSeconds * 1000;
const isTokenStillValid = (token) => {
  const jwtTokenContent = o(token);
  const nowEpochInSeconds = Date.now() / 1000;
  return !jwtTokenContent.exp || jwtTokenContent.exp > nowEpochInSeconds + oneMinuteInSeconds;
};
const getTokenRefreshTimeout = (token) => {
  const jwtTokenContent = o(token);
  const nowEpochInSeconds = Date.now() / 1000;
  if (!jwtTokenContent.exp) {
    return defaultTokenRefreshRate;
  }
  if (!isTokenStillValid(token)) {
    return 0;
  }
  return (jwtTokenContent.exp - nowEpochInSeconds - oneMinuteInSeconds) * 1000;
};
const btoajson = function (json) {
  return Buffer.from(JSON.stringify(json))
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};
// for tests
// adapted from https://github.com/hokaccha/node-jwt-simple/blob/master/lib/jwt.js
function createToken(payload) {
  return [btoajson({ typ: 'JWT', alg: 'none' }), btoajson(payload)].join('.');
}

export { getTokenFromCurrentLocation as a, getTokenRefreshTimeout as b, getUsernameFromToken as c, getToken as g, isTokenStillValid as i };
